module.exports = __webpack_public_path__ + "static/media/Inbar.7dfcb868.jpg";